"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_popper_tooltip_1 = require("react-popper-tooltip");
const classnames_1 = __importDefault(require("classnames"));
require("./tooltip.scss");
const Tooltip = (_a) => {
    var { children, content, config = {}, popperOptions = {}, theme = 'light', size = 'md', className } = _a, props = __rest(_a, ["children", "content", "config", "popperOptions", "theme", "size", "className"]);
    const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = (0, react_popper_tooltip_1.usePopperTooltip)(Object.assign({ interactive: true, trigger: 'hover', placement: 'bottom', delayHide: 100, delayShow: 100 }, config), Object.assign({ strategy: 'fixed' }, popperOptions));
    return ((0, jsx_runtime_1.jsxs)("span", Object.assign({ ref: setTriggerRef, className: (0, classnames_1.default)(className, 'tooltip') }, props, { children: [visible && ((0, jsx_runtime_1.jsxs)("span", Object.assign({ ref: setTooltipRef }, getTooltipProps({
                className: (0, classnames_1.default)('tooltip-container', `tooltip-${theme}`, `tooltip-${size}`)
            }), { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({}, getArrowProps({ className: 'tooltip-arrow' })), void 0), content] }), void 0)), children] }), void 0));
};
exports.default = Tooltip;
